import { alpha, Box, Typography, useTheme } from "@mui/material";
import QrCode2Icon from "@mui/icons-material/QrCode2";

export const QrCodeSignature: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => {
  const theme = useTheme();

  const src = value.startsWith("data:")
    ? value
    : `data:image/png;base64,${value}`;

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          mt: 0.15,
          color: theme.palette.primary.main,
          opacity: 0.8,
          flexShrink: 0,
          display: "flex",
        }}
      >
        <QrCode2Icon fontSize="small" />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: "0.62rem",
            display: "block",
            mb: 1,
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#ffffff",
            border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
            borderRadius: 1,
            p: 1.5,
            width: "fit-content",
          }}
        >
          <Box
            component="img"
            src={src}
            alt="QR Code"
            sx={{
              width: 140,
              height: 140,
              display: "block",
              imageRendering: "pixelated",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
